<h2 mat-dialog-title>{{ config.title }}</h2>
<mat-dialog-content>{{ config.text }}</mat-dialog-content>
<mat-dialog-actions>
  @if (config.showCloseButton) {
    <ui-button mat-dialog-close buttonStyle="text">Schließen</ui-button>
  }
  <ui-button (clicked)="startAppUpdateFlow()" buttonStyle="filled">Jetzt aktualisieren</ui-button>
</mat-dialog-actions>
